import { useEffect } from "react";

import { AMBIENTES, crearAmbiente } from "../../shared/ambiente";
import { temaOscuro } from "./temasUat";

/* EL AMBIENTE DEL TEMA, PUESTO EN LA PANTALLA (UAT).
 *
 * Cuelga un lienzo DETRÁS del contenido del armazón y arranca ahí la nieve,
 * los pétalos, las hojas o las estrellas del tema (ver `shared/ambiente.js`).
 *
 * ── POR QUÉ SE CUELGA A MANO Y NO CON JSX ───────────────────────────────────
 *
 * Tiene que ir ADENTRO del armazón para quedar por encima de su fondo y por
 * debajo de su contenido, y los armazones son dos (`Layout`, el rail, que es
 * el de producción, y `LayoutUAT`). Agregar un `<canvas>` en los dos sería
 * tocar el de producción por algo que sólo existe en la rama de prueba. Así
 * que este componente no dibuja nada: busca el armazón que esté montado y le
 * cuelga el lienzo. React no lo conoce y no lo toca.
 *
 * ── CUÁNDO NO ARRANCA ───────────────────────────────────────────────────────
 *
 *   · el tema no tiene ambiente (Industrial, Papel, Torre…), o es una
 *     variante que va quieta («Venom (cara)»: ver `VARIANTES_DE_TEMA`);
 *   · la persona pidió menos movimiento en su sistema;
 *   · no hay con qué dibujar.
 *
 * En los tres casos queda el fondo quieto de siempre. `data-ambiente` en la
 * raíz es lo que le avisa a la hoja que el quieto ya no hace falta —y sólo se
 * pone si el lienzo arrancó de verdad—: sacar los copos dibujados sin haber
 * puesto los que caen dejaría el tema sin nieve.
 */
const AmbienteTema = ({ tema, armazon }) => {
  useEffect(() => {
    if (!AMBIENTES[tema]) return undefined;
    if (window.matchMedia?.("(prefers-reduced-motion: reduce)").matches)
      return undefined;
    const casa = document.querySelector(".uat-hub, .hub");
    if (!casa) return undefined;

    const lienzo = document.createElement("canvas");
    lienzo.className = "ambiente-tema";
    lienzo.setAttribute("aria-hidden", "true");
    casa.appendChild(lienzo);

    const parar = crearAmbiente(lienzo, tema, {
      sobreClaro: !temaOscuro(tema),
    });
    if (!parar) {
      lienzo.remove();
      return undefined;
    }
    document.documentElement.setAttribute("data-ambiente", tema);

    return () => {
      parar();
      lienzo.remove();
      document.documentElement.removeAttribute("data-ambiente");
    };
    // `armazon` va en la lista: al pasar de barra a rail la casa es otra.
  }, [tema, armazon]);

  return null;
};

export default AmbienteTema;
